module.exports = __webpack_public_path__ + "89ef606feb5510cff83d38d44861aec7.svg";